import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import {
  ChevronUp,
  PlusCircle,
} from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../core/redux/action";
// import Select from 'react-select';
// import { DatePicker } from 'antd';
// import EditCategoryList from '../../core/modals/inventory/editcategorylist';
// import Swal from 'sweetalert2';
import Table from "../../core/pagination/datatable";
import Axios from "axios";
import { useEffect } from "react";
import { setdeliveryitems_data } from "../../core/redux/action";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { API_BASE_URL, GET_DELIVERY_CHALLAN } from "../../Config";
import { getUserPermissions } from "../../UserPermissions";
import DeliveryItemAdd from "../../core/modals/stocks/deliveryitemadd";
import DeliveryItemView from "../../core/modals/stocks/deliveryitemview";
import SpinLoader from "../loader/SpinLoader";
// import PrintContent from './print';

const DeliveryItem = () => {
  const [userDataSession, setUserDataSession] = useState({});
  const navigate = useNavigate();
  const [viewOrderObj, setViewOrderObj] = useState("");
  // const [orderViewData, setOrderViewData] = useState([]);
  // const [viewPayments, setViewPayments] = useState([]);

  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, []);

  const [permissions, setPermissions] = useState({
    isRead: "d-none",
    isWrite: "d-none",
    isDelete: "d-none",
    isExport: "d-none",
  });

  useEffect(() => {
    const perms = getUserPermissions("Categories");
    setPermissions(perms);
  }, []);

  const data = useSelector((state) => state.toggle_header);

  const dispatch = useDispatch();
  const dataSource = useSelector((state) => state.deliveryitems_data) || [];
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      setLoading(true);
      Axios.get(
        `${API_BASE_URL}${GET_DELIVERY_CHALLAN}?OrgId=${userDataSession.OrgId}`
      )
        .then((response) => {
          if (response.data.Status) {
            dispatch(setdeliveryitems_data(response.data.ResultData));
            setLoading(false);
          } else {
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  }, [dispatch, userDataSession]);

  // const [isFilterVisible, setIsFilterVisible] = useState(false);
  // const toggleFilterVisibility = () => {
  //     setIsFilterVisible((prevVisibility) => !prevVisibility);
  // };
  // const [selectedDate, setSelectedDate] = useState(new Date());
  // const handleDateChange = (date) => {
  //     setSelectedDate(date);
  // };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const columns = [
    {
      title: "Order No",
      dataIndex: "OrderNo",
      sorter: (a, b) => a.OrderNo.localeCompare(b.OrderNo),
    },
    {
      title: "Date",
      dataIndex: "Orderdate",
      sorter: (a, b) => new Date(a.Orderdate) - new Date(b.Orderdate),
      render: (text) => {
        const date = new Date(text);
        return date.toLocaleDateString("en-GB");
      },
    },
    {
      title: "Customer",
      dataIndex: "CustomerName",
      sorter: (a, b) => a.CustomerName.localeCompare(b.CustomerName),
    },

    {
      title: "Total",
      dataIndex: "Total",
      sorter: (a, b) => a.Total.localeCompare(b.Total),
    },

    {
      title: "Status",
      dataIndex: "IsActive",
      render: (IsActive) => (
        <span
          className={`badge badge-${IsActive === true ? "success" : "danger"}`}
        >
          {IsActive === true ? "Sold" : "Inactive"}
        </span>
      ),
      sorter: (a, b) => (a.IsActive ? 1 : -1) - (b.IsActive ? 1 : -1),
    },

    {
      title: "Actions",
      dataIndex: "actions",
      render: (text, record) => (
        <td className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className={`me-2 p-2 d-none ${permissions.isWrite}`}
              to="#"
              data-bs-toggle="offcanvas"
              // data-bs-target="#offcanvasRightCategoryEdit"
              // aria-controls="offcanvasRightCategoryEdit"
              data-id="code"
              // onClick={() => showEditModal(record)}
            >
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            <Link
              className={`me-2 conform-text p-2 ${permissions.isRead}`}
              to="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightViewDeliChal"
              aria-controls="offcanvasRightViewDeliChal"
              onClick={() => viewOrderClick(record)}
            >
              <i className="fa-regular fa-eye"></i>
            </Link>
            <Link
              className={`me-2 d-none conform-text p-2 ${permissions.isRead}`}
              to="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightSoldDeliChal"
              aria-controls="offcanvasRightSoldDeliChal"
              // onClick={() => viewOrderClick(record)}
            >
              <i className="fa-regular fa-circle-check"></i>
            </Link>
          </div>
        </td>
      ),
    },
  ];

  const viewOrderClick = (orderObj) => {
    setViewOrderObj(orderObj);
  };

  // const [editCategoryObj, setEditCategoryObj] = useState([]);

  // const showEditModal = (categoryObj) => {
  //     setEditCategoryObj(categoryObj); // Update the state with the ID of the category to edit
  // };

  const filteredData = dataSource.filter(
    (item) =>
      (item && // Check if item is defined
        item.OrderNo &&
        item.OrderNo.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.CustomerName &&
        item.CustomerName.toLowerCase().includes(searchQuery.toLowerCase()))
    // (item.Description && item.Description.toLowerCase().includes(searchQuery.toLowerCase())) ||
    // (item.Qty && item.Qty.toString().includes(searchQuery.toLowerCase()))
  );

  const handleDownloadExcel = () => {
    if (data.length === 0) {
      return; // Don't download if there is no data
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert your data to worksheet format
    const wsData = dataSource?.map((item) => ({
      "Order Number": item.OrderNo,
      Date: item.Date,
      Customer: item.CustomerName,
      Total: item.Total,
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "DelievryItems");

    // Save the workbook to a file
    XLSX.writeFile(wb, "DelievryItems.xlsx");
  };

  const generatePDF = () => {
    const doc = new jsPDF();

    // Set properties for PDF
    doc.setProperties({
      title: "Delivery Item",
      author: "Your Name",
      creator: "Your Application",
    });

    // Add data to PDF
    const tableData = []; // Your data array here

    // Add a header row
    const headers = ["Number", "Date", "Customer", "Total"];
    tableData.push(headers);

    // Add rows
    dataSource.forEach((item) => {
      const row = [];
      row.push(item.OrderNo, item.Date, item.CustomerName, item.Ttal);
      tableData.push(row);
    });

    // Generate table
    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    // Save the PDF
    doc.save("DelievryItems.pdf");
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Delivery Items</h4>
                <h6>Manage your deliveryitems</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li className={` ${permissions.isExport}`} onClick={generatePDF}>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li
                className={` ${permissions.isExport}`}
                onClick={handleDownloadExcel}
              >
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            <div className={`page-btn ${permissions.isRead}`}>
              <Link
                to="#"
                className="btn btn-added"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightDeliveryAdd"
                aria-controls="offcanvasRightDeliveryAdd"
              >
                <PlusCircle className="me-2" />
              </Link>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="input-group search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <span className="input-group-text bg-white">
                      <i data-feather="search" className="feather-search"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                {loading ? (
                  <SpinLoader />
                ) : (
                  // <div className="loader m-auto"></div>
                  <Table columns={columns} dataSource={filteredData} />
                )}
              </div>
            </div>
          </div>
          {/* /product list */}
          {/* <div className='d-none'>
                {invoiceData ? (
                    <PrintContent ref={printRef} data={invoiceData} invObj={INVObj} viewProducts={viewProducts} viewPayments={viewPayments} />
                ) : (
                    <p>Loading...</p>
                )}
            </div> */}
        </div>
      </div>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightSoldDeliChal"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "35%" }}
      >
        <div className="offcanvas-header d-flex justify-content-between align-items-center">
          <h4 id="offcanvasRightLabel" className="mb-0">
            Sold Product
          </h4>
          <div>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>
        </div>
        <hr />
        <div className="offcanvas-body">
          <div id="pdf-content">
            <div className="row">
              <div className="col-12">
                <label className="form-label">Customer</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter customer"
                />
              </div>
              <div className="col-12 mt-3">
                <label className="form-label">Product</label>
                <select className="form-select">
                  <option>Choose product</option>
                </select>
              </div>

              <div className="d-flex justify-content-center align-items-center mt-4">
                <button className="btn btn-info col-3 me-2">
                  Booked
                  <i className="fa-regular fa-circle-check mt-1 ms-1"></i>
                </button>
                <button className="btn btn-primary col-3">
                  Sold
                  <i className="fa-regular fa-circle-check mt-1 ms-1"></i>
                </button>
              </div>
            </div>
            <div className=""></div>
          </div>
        </div>
      </div>

      <DeliveryItemAdd />
      <DeliveryItemView deliveryViewObj={viewOrderObj} />
      {/* <EditCategoryList /> */}
      {/* <EditCategoryList categoryObj={editCategoryObj} /> */}
    </div>
  );
};

export default DeliveryItem;
